import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header.jsx';
import Footer from './components/Footer.jsx';

import Home from './pages/Home.jsx';
import Login from './pages/Login.jsx';
import Register from './pages/Register.jsx';
import Reservar from './pages/Reservar.jsx';
import Dashboard from './pages/Dashboard.jsx';
import CrearContrasena from './pages/CrearContrasena.jsx';
import Confirmacion from './pages/Confirmacion.jsx';
import EditarPerfil from './pages/EditarPerfil.jsx';
import CalendarioAdmin from './pages/admin/CalendarioAdmin.jsx';
import ServiciosAdmin from './pages/admin/ServiciosAdmin.jsx';
import ScrollToTop from './components/ScrollToTop.jsx';
import ClientesAdmin from './pages/admin/ClientesAdmin.jsx';
import HorariosAdmin from './pages/admin/HorariosAdmin.jsx';
import AsistenciasAdmin from './pages/admin/AsistenciasAdmin.jsx';
import FinanzasAdmin from './pages/admin/FinanzasAdmin.jsx';
import DiasEspecialesAdmin from './pages/admin/DiasEspecialesAdmin.jsx';
import SobreMi from './pages/SobreMi.jsx';
import BloqueadosAdmin from './pages/admin/BloqueadosAdmin.jsx';

import RequireAdminRoute from './components/RequireAdminRoute.jsx';
import PoliticaDeServicio from './pages/legal/PoliticaDeServicio.jsx';
import CondicionesSistemaCitas from './pages/legal/CondicionesSistemaCitas.jsx';
import PoliticaPrivacidad from './pages/legal/PoliticaPrivacidad.jsx';
import Error from './components/Error.jsx';
import AjustesAdmin from './pages/admin/AjustesAdmin.jsx';
import RecuperarContrasena from './pages/RecuperarContrasena.jsx';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="*" element={<Error />} />
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/recuperar-contrasena" element={<RecuperarContrasena />} />
        <Route path="/register" element={<Register />} />
        <Route path="/reservar" element={<Reservar />} />
        <Route path="/sobre-mi" element={<SobreMi />} />
        <Route path="/dashboard" element={<Dashboard />} />
        
        {/* Rutas admin protegidas */}
        <Route path="/dashboard/calendario" element={
          <RequireAdminRoute><CalendarioAdmin /></RequireAdminRoute>
        } />
        <Route path="/dashboard/servicios" element={
          <RequireAdminRoute><ServiciosAdmin /></RequireAdminRoute>
        } />
        <Route path="/dashboard/clientes" element={
          <RequireAdminRoute><ClientesAdmin /></RequireAdminRoute>
        } />
        <Route path="/dashboard/horario-de-trabajo" element={
          <RequireAdminRoute><HorariosAdmin /></RequireAdminRoute>
        } />
        <Route path="/dashboard/asistencias" element={
          <RequireAdminRoute><AsistenciasAdmin /></RequireAdminRoute>
        } />
        <Route path="/dashboard/finanzas" element={
          <RequireAdminRoute><FinanzasAdmin /></RequireAdminRoute>
        } />
        <Route path="/dashboard/bloqueados" element={
          <RequireAdminRoute><BloqueadosAdmin /></RequireAdminRoute>
        } />
        <Route path="/dashboard/dias-especiales" element={
          <RequireAdminRoute><DiasEspecialesAdmin /></RequireAdminRoute>
        } />
                <Route path="/dashboard/ajustes-del-sistema" element={
          <RequireAdminRoute><AjustesAdmin /></RequireAdminRoute>
        } />

        <Route path="/crear-contrasena" element={<CrearContrasena />} />
        <Route path="/confirmacion" element={<Confirmacion />} />
        <Route path="/editar-perfil" element={<EditarPerfil />} />
        <Route path="/politica-de-servicio" element={<PoliticaDeServicio/>}/>
        <Route path="/condiciones-del-sistema-de-citas" element={<CondicionesSistemaCitas/>}/>
        <Route path="/politica-de-privacidad" element={<PoliticaPrivacidad/>}/>
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
